import { useState, useEffect } from "react";
import { loadShowCourseImageInPortalDisplaySetting } from "./useLearningActivityCardState.utils";

export const useDisplayLearningActivityCardImage = () => {
  const [displayImage, setDisplayImage] = useState(null);

  useEffect(() => {
    const mountedRef = { current: true };

    loadShowCourseImageInPortalDisplaySetting(mountedRef, setDisplayImage);

    return () => {
      mountedRef.current = false;
    };
  }, []);

  return displayImage;
};
